<template lang="html">
  <div class="text__title">
    <component :is="tag" :class="{ text__inner: true, bold: bold, adaptive: adaptive }">
      <!-- @slot Безымянный слот. Используется для вставки текста-->
      <slot/>
    </component>
  </div>
</template>

<script>
export default {
  name: 'bimTextH5',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h5'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__title .text__inner {
  margin: 0;
  font-size: 32px;
  font-weight: normal;
  line-height: 1.13;
  letter-spacing: normal;
}

.text__title .text__inner.bold {
  font-weight: bold;
}

@media all and (max-width: $phone-width) {
  .text__inner.adaptive {
    font-size: 24px;
    line-height: 1.29;
  }
}
</style>
